/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect } from 'react';
import { shareBiddings, shareFollowups } from 'services/actions/share_actions';
import companyId from 'services/company_id';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { Container } from './styles';

interface ItemShareProps {
  setShowShareWindow: React.Dispatch<React.SetStateAction<boolean>>;
  selectedItems: Array<number>;
  source?: 'bidding' | 'followup';
  getShareHtml?: () => string;
  shareBoxLayout?: 'popover' | 'inline';
}

const ItemShare = (props: ItemShareProps) => {
  const {
    setShowShareWindow,
    selectedItems,
    source = 'bidding',
    getShareHtml,
    shareBoxLayout = 'popover',
  } = props;
  const [email, setEmail] = useState<string>('');
  const [showProgress, setShowProgress] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  useEffect(() => {
    if (!showError) return;
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);

  useEffect(() => {
    if (!showSuccess) return;

    setTimeout(() => {
      setShowShareWindow(false);
    }, 2000);
  }, [showSuccess]);

  return (
    <Container $shareBoxLayout={shareBoxLayout}>
      <div className="form-inline bidding-share">
        <div className="row justify-content-end">
          <button
            type="button"
            aria-label="Fechar"
            className="close bidding-share-close bg-transparent border-0 position-relative"
            onClick={() => setShowShareWindow(false)}
          >
            <span aria-hidden="true">×</span>
          </button>
          <div className="col-md-12 input-group">
            {showSuccess ? (
              <div className="col-md-12">
                <div className="alert alert-success m-0">Compartilhado com sucesso!</div>
              </div>
            ) : (
              <>
                <input
                  type="text"
                  className={`form-control ${showError && 'is-invalid'}`}
                  placeholder="Email do destinatário"
                  onChange={(event) => setEmail(event.target.value)}
                  value={email}
                />
                <div className="input-group-prepend">
                  <button
                    type="submit"
                    className="btn btn-sm btn-primary"
                    onClick={() => {
                      setShowProgress(true);

                      if (source === 'bidding') {
                        const shareHtml = getShareHtml?.();
                        if (getShareHtml && (shareHtml == null || shareHtml.trim() === '')) {
                          setShowProgress(false);
                          setShowError(true);
                          return;
                        }
                        shareBiddings(
                          selectedItems,
                          email,
                          setShowProgress,
                          setShowError,
                          setShowSuccess,
                          companyId(profile),
                          false,
                          shareHtml,
                        );
                      }

                      if (source === 'followup')
                        shareFollowups(
                          selectedItems,
                          email,
                          setShowProgress,
                          setShowError,
                          setShowSuccess,
                          companyId(profile),
                        );
                    }}
                  >
                    Enviar
                  </button>
                </div>
              </>
            )}
            {showError && <div className="invalid-tooltip">Digite um email válido</div>}
          </div>
          <div
            className={`${showProgress ? '' : 'invisible'} progress col-md-12 p-0`}
            style={{ height: '5px' }}
          >
            <div
              className="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              aria-valuenow={75}
              aria-valuemin={0}
              aria-valuemax={100}
              style={{ width: '100%' }}
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ItemShare;
